import {agendaDirectory} from "./access/patientDirectory";
import {
  getDeviceTimeZone,
  localizeScheduleEntry
} from "./utils/timezone";
import {
  useEffect,
  useState,
  useRef
} from "react";

import {
  db,
  storage
} from "./firebase";

import {
  sendWhatsAppVPS,
  sendWhatsAppFileVPS,
  sendFileToWhatsApp
} from "./services/whatsappVPS";

import { useClinic }
  from "./context/ClinicContext";

import {
    collection,
    onSnapshot,
    query,
    orderBy,
    addDoc,
    doc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    where,
    limit,
    writeBatch
} from "./access/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import FileViewerModal
  from "./FileViewerModal";

import EmojiPicker from "emoji-picker-react";
import {
  Paperclip,
  Smile,
  Mic,
  Square,
  Send,
  LoaderCircle,
  Image as ImageIcon,
  FileText
} from "lucide-react";
import {
  WhatsAppAvatar,
  WhatsAppThread
} from "./whatsapp/WhatsAppMessageBubble";

function FileBadge({

    type,

    color,

    filename,

    buttonText,

    onOpen

}) {

    return (

        <div
        style={{
            minWidth:220
        }}
        >

            <div
            style={{
                width:56,
                height:56,
                borderRadius:12,
                background:color,
                color:"#fff",
                fontWeight:700,
                fontSize:16,
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                marginBottom:10
            }}
            >

                {type}

            </div>

            <div
            style={{
                fontSize:14,
                fontWeight:500,
                wordBreak:"break-word",
                marginBottom:10
            }}
            >

                {filename}

            </div>

            <button

                onClick={onOpen}

                style={{

                    width:"100%",

                    padding:"10px 14px",

                    background:"#2563eb",

                    color:"#fff",

                    border:"none",

                    borderRadius:10,

                    cursor:"pointer",

                    fontWeight:600

                }}

            >

                {buttonText}

            </button>

        </div>

    );

}

export default function PatientWhatsAppPanel({

    paciente,

    setSeccion

}) {

  const {
    clinicData,
    clinicId
  } = useClinic();
  const deviceTimeZone = getDeviceTimeZone();

  const [
    conversation,
    setConversation
  ] = useState(null);

  const [
    draftConversation,
    setDraftConversation
  ] = useState(null);

  const [
    messages,
    setMessages
  ] = useState([]);

  const [
    patientSummary,
    setPatientSummary
  ] = useState({
    nextAppointment: null,
    balance: 0,
    lastTreatment: "-"
  });

  const [
    newMessage,
    setNewMessage
  ] = useState("");

  const [
    showEmojiPicker,
    setShowEmojiPicker
  ] = useState(false);

  const [
    showAttachmentMenu,
    setShowAttachmentMenu
  ] = useState(false);

  const [
    selectedFile,
    setSelectedFile
  ] = useState(null);

  const [
    showFilePreview,
    setShowFilePreview
  ] = useState(false);

  const [
    previewUrl,
    setPreviewUrl
  ] = useState("");

  const [
    fileCaption,
    setFileCaption
  ] = useState("");

  const [
    uploadingFile,
    setUploadingFile
  ] = useState(false);

  const [
    sending,
    setSending
  ] = useState(false);

  const [
    viewerOpen,
    setViewerOpen
    ] = useState(false);

    const [
    viewerUrl,
    setViewerUrl
    ] = useState("");

    const [
    viewerName,
    setViewerName
    ] = useState("");

    const [
    viewerMimeType,
    setViewerMimeType
    ] = useState("");

    const [
        showDeleteConversationModal,
        setShowDeleteConversationModal
    ] = useState(false);

    const [
    isRecording,
    setIsRecording
    ] = useState(false);

    const [
    audioBlob,
    setAudioBlob
    ] = useState(null);

    const [
    audioPreview,
    setAudioPreview
    ] = useState("");

    const [
    recordingTime,
    setRecordingTime
    ] = useState(0);

    const [
        emojiPickerPosition,
        setEmojiPickerPosition
    ] = useState({
        left:0,
        top:0
    });

    const activeConversation =
    conversation ||
    draftConversation;

    const openFileViewer = (
    fileUrl,
    filename,
    mimeType
    ) => {

    setViewerUrl(
        fileUrl
    );

    setViewerName(
        filename || ""
    );

    setViewerMimeType(
        mimeType || ""
    );

    setViewerOpen(
        true
    );

    };

  const messagesEndRef =
    useRef(null);

  const fileInputRef =
    useRef(null);  

  const mediaRecorderRef =
    useRef(null);

  const audioChunksRef =
    useRef([]);

  const recordingIntervalRef =
    useRef(null);  

  const emojiButtonRef =
    useRef(null);

  const emojiPickerRef =
    useRef(null);

  const messageInputRef =
    useRef(null);     

  async function handleSendMessage() {

        if (sending) {
            return;
        }

        if (
            !newMessage.trim() ||
            !activeConversation
        ) {
            return;
        }

        setSending(true);

        try {

            const result =
                await sendWhatsAppVPS(

                    clinicId,

                    activeConversation.whatsapp ||
                    activeConversation.id?.replace(
                        "@c.us",
                        ""
                    ),

                    newMessage,

                    activeConversation.patientId,

                    activeConversation.patientName

                );

            if (result?.success) {

                setNewMessage("");

                if (draftConversation) {

                    setDraftConversation(
                        null
                    );

                }

            } else {

                console.log(
                    "RESULTADO COMPLETO:",
                    result
                );

                alert(
                    JSON.stringify(
                        result,
                        null,
                        2
                    )
                );

            }

        } finally {

            setSending(false);

        }

    }

  function handleFileSelected(
    event
    ) {

    const file =
        event.target.files?.[0];

    if (!file) {
        return;
    }

    setSelectedFile(
        file
    );

    const url =
        URL.createObjectURL(
            file
        );

    setPreviewUrl(
        url
    );

    setShowFilePreview(
        true
    );

  }

  function openAttachmentPicker(accept) {

    if (fileInputRef.current) {
      fileInputRef.current.accept = accept;
      fileInputRef.current.click();
    }

    setShowAttachmentMenu(false);

  }

  async function startRecording() {

    try {

        const stream =
        await navigator.mediaDevices.getUserMedia({
            audio:true
        });

        const mediaRecorder =
        new MediaRecorder(stream);

        mediaRecorderRef.current =
        mediaRecorder;

        audioChunksRef.current =
        [];

        mediaRecorder.ondataavailable =
        event => {

            if (event.data.size > 0) {

            audioChunksRef.current.push(
                event.data
            );

            }

        };

        mediaRecorder.onstop = () => {

        const blob =
            new Blob(
            audioChunksRef.current,
            {
                type:"audio/webm"
            }
            );

        setAudioBlob(
            blob
        );

        setAudioPreview(
            URL.createObjectURL(
            blob
            )
        );

        stream
            .getTracks()
            .forEach(track =>
            track.stop()
            );

        };

        mediaRecorder.start();

        setRecordingTime(0);

        recordingIntervalRef.current =
        setInterval(() => {

            setRecordingTime(
            prev => prev + 1
            );

        },1000);

        setIsRecording(true);

    } catch(error) {

        console.error(error);

        alert(
        "No se pudo acceder al micrófono"
        );

    }

  }

  function stopRecording() {

    if (
        mediaRecorderRef.current
    ) {

        mediaRecorderRef.current.stop();

    }

    clearInterval(
        recordingIntervalRef.current
    );

    setIsRecording(false);

  }

  async function confirmDeleteConversation() {

    if (!conversation) {
        return;
    }

    try {

        const messagesRef = collection(

            db,

            "clinics",

            clinicId,

            "whatsappConversations",

            conversation.id,

            "messages"

        );

        const messagesSnap = await getDocs(messagesRef);

        const BATCH_SIZE = 450;

        let batch = writeBatch(db);

        let operationCount = 0;

        for (const message of messagesSnap.docs) {

            batch.delete(
                message.ref
            );

            operationCount++;

            if (operationCount >= BATCH_SIZE) {

                await batch.commit();

                batch = writeBatch(db);

                operationCount = 0;

            }

        }

        batch.delete(

            doc(

                db,

                "clinics",

                clinicId,

                "whatsappConversations",

                conversation.id

            )

        );

        await batch.commit();

        setConversation(null);

        setShowDeleteConversationModal(
            false
        );

    } catch(error) {

        console.error("ERROR ELIMINANDO CONVERSACIÓN:", error);

        console.error(error.stack);

        setShowDeleteConversationModal(false);

        alert(error.message);

    }

  }

  async function loadPatientSummary(
    patientId
    ) {

    try {

        const citasQuery = query(

        agendaDirectory(db,clinicId),

        where(
            "pacienteId",
            "==",
            patientId
        )

        );

        const citasSnap =
        await getDocs(
            citasQuery
        );

        const citas =
        citasSnap.docs.map(
            doc => localizeScheduleEntry({
            id: doc.id,
            ...doc.data()
            }, deviceTimeZone)
        );

        const now = new Date();

        const futuras = citas
        .filter(cita => {

            if (
            cita.estado ===
            "cancelada"
            ) {
            return false;
            }

            const fechaHora =
            new Date(
                `${cita.fecha}T${cita.hora}`
            );

            return fechaHora >= now;

        })
        .sort((a, b) => {

            const fechaA =
            new Date(
                `${a.fecha}T${a.hora}`
            );

            const fechaB =
            new Date(
                `${b.fecha}T${b.hora}`
            );

            return fechaA - fechaB;

        });

        const proximaCita =
        futuras[0] || null;

        const saldoTotal =
        citas.reduce(
            (acc, cita) => {

            if (
                cita.estado === "cancelada"
            ) {
                return acc;
            }

            return (
                acc +
                Number(cita.saldo || 0)
            );

            },
            0
        );

        const ultimaCita =
        citas
            .filter(
            cita =>
                cita.estado !==
                "cancelada"
            )
            .sort((a, b) => {

            const fechaA =
                new Date(
                `${a.fecha}T${a.hora}`
                );

            const fechaB =
                new Date(
                `${b.fecha}T${b.hora}`
                );

            return fechaB - fechaA;

            })[0];

        setPatientSummary({

        nextAppointment:
            proximaCita,

        balance:
            saldoTotal,

        lastTreatment:
            ultimaCita?.motivo || "-"

        });

    } catch (error) {

        console.error(
        "Error cargando resumen:",
        error
        );

    }

  }

  function handleStartConversation() {

      const phone =
          (
              paciente.whatsapp ||
              paciente.telefono ||
              ""
          ).replace(/\D/g, "");

      if (!phone) {

          alert(
              "El paciente no tiene un número de WhatsApp."
          );

          return;

      }

      setDraftConversation({

          id: `${phone}@c.us`,

          whatsapp: phone,

          patientId: paciente.id,

          patientName:
              `${paciente.nombre || ""} ${paciente.apellidos || ""}`.trim()

      });

  }

  useEffect(() => {
    if (!clinicId || !paciente?.id) {
      setConversation(null);
      return;
    }

    const normalizarTelefono = (valor) => {
      const digitos = String(valor || "")
        .replace(/@c\.us$/i, "")
        .replace(/\D/g, "");

      // Para números mexicanos, compara los últimos 10 dígitos.
      return digitos.length >= 10
        ? digitos.slice(-10)
        : digitos;
    };

    const telefonosPaciente = [
      paciente.whatsapp,
      paciente.telefono
    ]
      .map(normalizarTelefono)
      .filter(Boolean);

    const conversacionesRef = collection(
      db,
      "clinics",
      clinicId,
      "whatsappConversations"
    );

    const unsubscribe = onSnapshot(
      conversacionesRef,
      (snapshot) => {
        const conversaciones = snapshot.docs.map((item) => ({
          id: item.id,
          ...item.data()
        }));

        // Primero buscamos la asociación directa con el expediente.
        let coincidencias = conversaciones.filter(
          (item) => item.patientId === paciente.id
        );

        // Si no existe, buscamos por número telefónico.
        if (coincidencias.length === 0) {
          coincidencias = conversaciones.filter((item) => {
            const telefonosConversacion = [
              item.whatsapp,
              item.id
            ]
              .map(normalizarTelefono)
              .filter(Boolean);

            return telefonosConversacion.some((telefono) =>
              telefonosPaciente.includes(telefono)
            );
          });
        }

        if (coincidencias.length === 0) {
          setConversation(null);
          return;
        }

        // Preferimos la conversación vinculada directamente
        // al paciente; después, la que tenga actividad más reciente.
        coincidencias.sort((a, b) => {
          const vinculadaA = a.patientId === paciente.id ? 1 : 0;
          const vinculadaB = b.patientId === paciente.id ? 1 : 0;

          if (vinculadaA !== vinculadaB) {
            return vinculadaB - vinculadaA;
          }

          const fechaA = a.lastMessageAt?.toMillis
            ? a.lastMessageAt.toMillis()
            : 0;

          const fechaB = b.lastMessageAt?.toMillis
            ? b.lastMessageAt.toMillis()
            : 0;

          return fechaB - fechaA;
        });

        setConversation(coincidencias[0]);
      },
      (error) => {
        console.error(
          "Error cargando conversación del paciente:",
          error
        );
      }
    );

    return unsubscribe;
  }, [
    clinicId,
    paciente?.id,
    paciente?.whatsapp,
    paciente?.telefono
  ]);

  useEffect(()=>{

    function handleClick(event){

        if(

            emojiPickerRef.current &&

            !emojiPickerRef.current.contains(event.target)

            &&

            !emojiButtonRef.current.contains(event.target)

        ){

            setShowEmojiPicker(false);

        }

    }

    document.addEventListener(
        "mousedown",
        handleClick
    );

    return ()=>{

        document.removeEventListener(
            "mousedown",
            handleClick
        );

    };

  },[]);

  useEffect(()=>{

    function handleKey(event){

        if(event.key==="Escape"){

            setShowEmojiPicker(false);

        }

    }

    window.addEventListener(
        "keydown",
        handleKey
    );

    return ()=>{

        window.removeEventListener(
            "keydown",
            handleKey
        );

    };

  },[]);

  useEffect(() => {

    if (!conversation) {

        setMessages([]);

        return;
    }

    const q = query(

        collection(
        db,
        "clinics",
        clinicId,
        "whatsappConversations",
        conversation.id,
        "messages"
        ),

        orderBy(
        "timestamp",
        "asc"
        )

    );

    const unsubscribe =
        onSnapshot(
        q,
        snapshot => {

            setMessages(

            snapshot.docs.map(
                doc => ({
                id: doc.id,
                ...doc.data()
                })
            )

            );

        }
        );

    return unsubscribe;

    }, [
    clinicId,
    conversation
  ]);

  useEffect(()=>{

    function updatePosition(){

        if(

            !showEmojiPicker ||

            !emojiButtonRef.current

        ){

            return;

        }

        const rect =
            emojiButtonRef.current.getBoundingClientRect();

        setEmojiPickerPosition({

            left:rect.left,

            top:rect.top

        });

    }

    window.addEventListener(
        "resize",
        updatePosition
    );

    window.addEventListener(
        "scroll",
        updatePosition,
        true
    );

    return ()=>{

        window.removeEventListener(
            "resize",
            updatePosition
        );

        window.removeEventListener(
            "scroll",
            updatePosition,
            true
        );

    };

  },[
    showEmojiPicker
  ]);

  useEffect(() => {

    messagesEndRef.current
        ?.scrollIntoView({
        behavior:"smooth"
        });

  }, [messages]);

  useEffect(() => {

    if (
        !conversation?.patientId
    ) {

        setPatientSummary({
        nextAppointment: null,
        balance: 0,
        lastTreatment: "-"
        });

        return;
    }

    loadPatientSummary(
        conversation.patientId
    );

    }, [
    conversation,
    clinicId
    ]);

  return (

    <div className="vd-whatsapp-page vd-whatsapp-patient-page" style={{
      display:"flex",
      height:"calc(100vh - 40px)",
      background:"#fff",
      borderRadius:16,
      overflow:"hidden"
    }}>

      {/* CHAT */}

        <div className="vd-whatsapp-conversation-stage" style={{
        flex:1,
        display:"flex",
        flexDirection:"column"
        }}>

        {!activeConversation ? (

            <div className="vd-whatsapp-chat-header"
                style={{
                    flex:1,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    flexDirection:"column",
                    gap:18,
                    color:"#64748b",
                    textAlign:"center",
                    padding:40
                }}
            >

                <div
                    style={{
                        fontSize:64
                    }}
                >
                    💬
                </div>

                <div
                    style={{
                        fontSize:20,
                        fontWeight:600,
                        color:"#334155"
                    }}
                >
                    Este paciente aún no tiene conversaciones.
                </div>

                <div
                    style={{
                        maxWidth:420,
                        lineHeight:1.6
                    }}
                >
                    Cuando envíes el primer mensaje desde VexaDent o el paciente escriba por WhatsApp, la conversación aparecerá automáticamente aquí.
                </div>

                <button

                    onClick={handleStartConversation}

                    style={{

                        display:"flex",

                        alignItems:"center",

                        justifyContent:"center",

                        gap:10,
                        
                        marginTop: 18,

                        padding:"14px 26px",

                        background:"#22c55e",

                        color:"#fff",

                        border:"none",

                        borderRadius:12,

                        cursor:"pointer",

                        fontWeight:700,

                        fontSize:16,

                        boxShadow:
                            "0 8px 20px rgba(34,197,94,.25)",

                        transition:
                            "all .2s ease"

                    }}

                    onMouseEnter={e=>{

                        e.currentTarget.style.background="#16a34a";

                        e.currentTarget.style.transform="translateY(-2px)";

                        e.currentTarget.style.boxShadow=
                            "0 12px 28px rgba(34,197,94,.35)";

                    }}

                    onMouseLeave={e=>{

                        e.currentTarget.style.background="#22c55e";

                        e.currentTarget.style.transform="translateY(0)";

                        e.currentTarget.style.boxShadow=
                            "0 8px 20px rgba(34,197,94,.25)";

                    }}

                >

                    <span
                        style={{
                            fontSize:22
                        }}
                    >
                        💬
                    </span>

                    Iniciar conversación

                </button>

            </div>

        ) : (

            <>

            <div
                style={{
                    padding:20,
                    borderBottom:
                    "1px solid #e5e7eb"
                }}
            >

                <div
                    style={{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"center"
                    }}
                    >

                    <WhatsAppAvatar conversation={activeConversation} size={46} />

                        <div
                            style={{
                                fontWeight:700,
                                fontSize:18
                            }}
                          >

                            {activeConversation.patientName ||
                            activeConversation.whatsapp}

                        </div>

                        <button

                            onClick={() =>

                                setShowDeleteConversationModal(
                                    true
                                )

                            }

                            style={{

                                background:"#ef4444",

                                color:"#fff",

                                border:"none",

                                padding:"8px 14px",

                                borderRadius:10,

                                cursor:"pointer",

                                fontWeight:600

                            }}

                        >

                            🗑 Eliminar

                    </button>

                </div>

                <div style={{
                    marginTop:8,
                    color:"#64748b",
                    fontSize:13,
                    display:"flex",
                    flexDirection:"column",
                    gap:4
                }}>

                    <div>
                        Próxima cita: {

                            patientSummary.nextAppointment
                            ? (() => {

                                const fecha = new Date(
                                    `${patientSummary.nextAppointment.fecha}T${patientSummary.nextAppointment.hora}`
                                );

                                return fecha.toLocaleString(
                                    "es-MX",
                                    {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true
                                    }
                                );

                                })()
                            : "Sin cita programada"

                        }
                        </div>

                        <div>
                        Saldo pendiente: $

                        {patientSummary.balance.toLocaleString()}
                        </div>

                        <div>
                        Último tratamiento: {patientSummary.lastTreatment}
                    </div>

                </div>

            </div>

            <div className="vd-whatsapp-thread-shell" style={{
                flex:1,
                overflowY:"auto",
                padding:20
            }}>

                <WhatsAppThread
                    messages={messages}
                    onOpenFile={openFileViewer}
                    bottomRef={messagesEndRef}
                />

                <div style={{display:"none"}} aria-hidden="true">

                {messages.map(message => (

                <div
                    key={message.id}
                    style={{
                    marginBottom:12,
                    display:"flex",
                    justifyContent:
                        message.fromMe
                        ? "flex-end"
                        : "flex-start"
                    }}
                >

                    <div style={{

                        background:

                            message.type === "sticker"

                                ? "transparent"

                                : message.fromMe

                                    ? "#dcfce7"

                                    : "#f1f5f9",

                        padding:

                            message.type === "sticker"

                                ? 0

                                : "10px 14px",

                        borderRadius:12,

                        maxWidth:

                            message.type === "sticker"

                                ? 190

                                : "70%"

                    }}>

                        <div>

                        {
                        message.type === "file" ||

                        message.type === "image" ||

                        message.type === "document" ||

                        message.type === "audio" ||

                        message.type === "video" ||

                        message.type === "sticker"

                        ? (

                        <>

                            {
                                message.type === "image" && (

                                <img

                                    src={message.fileUrl}

                                    alt=""

                                    onClick={()=>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                    style={{

                                        maxWidth:260,

                                        maxHeight:260,

                                        borderRadius:12,

                                        cursor:"pointer",

                                        display:"block"

                                    }}

                                />

                                )
                            }

                            {
                                message.type === "sticker" && (

                                <img

                                    src={message.fileUrl}

                                    alt="Sticker"

                                    style={{

                                        width:170,

                                        height:"auto",

                                        display:"block",

                                        cursor:"pointer",

                                        userSelect:"none"

                                    }}

                                    onClick={()=>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                message.mimeType ===
                                "application/pdf" && (

                                <FileBadge

                                    type="PDF"

                                    color="#dc2626"

                                    filename={message.filename}

                                    buttonText="Ver PDF"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                message.mimeType?.startsWith(
                                    "audio/"
                                ) && (

                                    <div
                                        style={{

                                            minWidth:250,

                                            padding:10,

                                            borderRadius:12,

                                            background:

                                            message.fromMe

                                            ? "#a7d7b5"

                                            : "#d9dde3"

                                        }}
                                    >

                                        <audio

                                            controls

                                            preload="metadata"

                                            src={message.fileUrl}

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                        <div
                                            style={{
                                                marginTop:6,
                                                fontSize:12,
                                                color:"#475569",
                                                wordBreak:"break-word"
                                            }}
                                        >

                                            {message.filename}

                                        </div>

                                    </div>

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

                                    ||

                                    message.mimeType ===
                                    "application/msword"

                                ) && (

                                <FileBadge

                                    type="DOCX"

                                    color="#2563eb"

                                    filename={message.filename}

                                    buttonText="Ver Documento"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.presentationml.presentation"

                                    ||

                                    message.filename?.toLowerCase()
                                    .endsWith(".pptx")

                                ) && (

                                <FileBadge

                                    type="PPTX"

                                    color="#ea580c"

                                    filename={message.filename}

                                    buttonText="Ver Presentación"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                                    ||

                                    message.filename?.toLowerCase()
                                    .endsWith(".xlsx")

                                ) && (

                                <FileBadge

                                    type="XLSX"

                                    color="#15803d"

                                    filename={message.filename}

                                    buttonText="Ver Excel"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                !message.mimeType?.startsWith(
                                    "image/"
                                ) &&

                                message.mimeType !==
                                "application/pdf" &&

                                !message.mimeType?.startsWith(
                                    "audio/"
                                ) &&

                                message.mimeType !==
                                "application/msword" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.presentationml.presentation" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&

                                !message.filename?.toLowerCase()
                                .endsWith(".xlsx") && (

                                    <FileBadge

                                        type="FILE"

                                        color="#64748b"

                                        filename={message.filename}

                                        buttonText="Abrir"

                                        onOpen={() => {

                                            console.log(
                                                "ARCHIVO ABIERTO",
                                                {
                                                    filename:
                                                        message.filename,

                                                    mimeType:
                                                        message.mimeType,

                                                    fileUrl:
                                                        message.fileUrl
                                                }
                                            );

                                            openFileViewer(

                                                message.fileUrl,

                                                message.filename,

                                                message.mimeType

                                            );

                                        }}

                                    />

                                )
                            }

                            {
                            message.caption && (

                            <div
                            style={{
                                marginTop:8
                            }}
                            >

                                {message.caption}

                            </div>

                            )
                            }

                        {
                            message.fromMe &&
                            message.status === "sending" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#f59e0b"
                            }}
                            >

                            ⏳ Enviando...

                            </div>

                            )
                        }

                        {
                            message.fromMe &&
                            message.status === "sent" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#22c55e"
                            }}
                            >

                            ✓ Enviado

                            </div>

                            )
                        }

                        {
                            message.fromMe &&
                            message.status === "failed" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#ef4444"
                            }}
                            >

                            ✕ Error al enviar

                            </div>

                            )
                        }

                        </>

                        ) : (

                        message.body

                        )
                        }

                        </div>

                        <div style={{

                            fontSize:11,

                            color:"#64748b",

                            marginTop:6,

                            textAlign:

                                message.type === "sticker"

                                    ? "center"

                                    : "right"

                        }}>

                            {message.timestamp?.toDate
                            ? message.timestamp
                                .toDate()
                                .toLocaleTimeString(
                                    [],
                                    {
                                    hour:"2-digit",
                                    minute:"2-digit"
                                    }
                                )
                            : ""}

                        </div>

                    </div>

                </div>

                ))}

                <div ref={messagesEndRef} />

                </div>

                    </div>

                    {
                        audioPreview && (

                        <div
                            style={{
                                padding:16,
                                borderTop:"1px solid #e5e7eb",
                                background:"#fff"
                            }}
                        >

                            <audio

                                controls

                                src={audioPreview}

                                style={{
                                    width:"100%"
                                }}

                            />

                            <div
                                style={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    gap:12,
                                    marginTop:12
                                }}
                            >

                                <button

                                    onClick={() => {

                                        setAudioBlob(null);

                                        setAudioPreview("");

                                    }}

                                >

                                    Eliminar

                                </button>

                                <button

                                    onClick={async () => {

                                        try {

                                            if (!audioBlob) {
                                                return;
                                            }

                                            const audioFile =
                                                new File(

                                                    [audioBlob],

                                                    `audio-${Date.now()}.webm`,

                                                    {
                                                        type:"audio/webm"
                                                    }

                                                );

                                            const {
                                                result,
                                                fileDoc
                                            } = await sendFileToWhatsApp({

                                                clinicId,

                                                phone:
                                                    conversation.whatsapp ||
                                                    conversation.id?.replace(
                                                    "@c.us",
                                                    ""
                                                    ),

                                                file:
                                                    audioFile,

                                                caption:"",

                                                conversationId:
                                                    conversation.id,

                                                patientId:
                                                    conversation.patientId,

                                                db,

                                                storage,

                                                collection,

                                                addDoc,

                                                ref,

                                                uploadBytes,

                                                getDownloadURL

                                            });

                                            if (
                                                result?.success &&
                                                fileDoc?.id
                                            ) {

                                                await updateDoc(

                                                    doc(

                                                        db,

                                                        "clinics",

                                                        clinicId,

                                                        "whatsappConversations",

                                                        conversation.id,

                                                        "messages",

                                                        fileDoc.id

                                                    ),

                                                    {

                                                        status:"sent"

                                                    }

                                                );

                                            }

                                            setAudioBlob(
                                                null
                                            );

                                            setAudioPreview(
                                                ""
                                            );

                                        } catch(error) {

                                            console.error(
                                                error
                                            );

                                            alert(
                                                error.message
                                            );

                                        }

                                    }}

                                >

                                    Enviar Audio

                                </button>

                            </div>

                        </div>

                        )
                    }

                <div className="vd-whatsapp-composer" style={{
                    padding:16,
                    borderTop:"1px solid #e5e7eb",
                    display:"flex",
                    gap:12,
                    alignItems:"center"
                }}>

                    {
                        showEmojiPicker && (

                        <div

                            ref={emojiPickerRef}

                            style={{

                                position:"fixed",

                                left:emojiPickerPosition.left,

                                top:emojiPickerPosition.top,

                                transform:"translateY(calc(-100% - 12px))",

                                zIndex:99999,

                                boxShadow:
                                    "0 15px 40px rgba(0,0,0,.20)",

                                borderRadius:18,

                                overflow:"hidden"

                            }}

                        >

                        <EmojiPicker

                            lazyLoadEmojis

                            previewConfig={{
                                showPreview:false
                            }}

                            skinTonesDisabled

                            onEmojiClick={(emoji)=>{

                                const input =
                                    messageInputRef.current;

                                if(!input){

                                    return;

                                }

                                const start =
                                    input.selectionStart;

                                const end =
                                    input.selectionEnd;

                                const text =
                                    newMessage;

                                const newText =

                                    text.substring(0,start)

                                    +

                                    emoji.emoji

                                    +

                                    text.substring(end);

                                setNewMessage(
                                    newText
                                );

                                requestAnimationFrame(()=>{

                                    input.focus();

                                    const pos =
                                        start +
                                        emoji.emoji.length;

                                    input.setSelectionRange(
                                        pos,
                                        pos
                                    );

                                });

                            }}

                        />

                        </div>

                        )
                    }

                    <button

                        type="button"

                        className="vd-wa-composer-icon vd-wa-composer-attach"

                        title="Adjuntar archivo"

                        aria-label="Adjuntar archivo"

                        onClick={() => {
                            setShowAttachmentMenu(
                                current => !current
                            );
                            setShowEmojiPicker(false);
                        }}

                        style={{
                            padding:"12px",
                            border:"none",
                            borderRadius:10,
                            cursor:"pointer",
                            background:"#f1f5f9"
                        }}

                    >

                        <Paperclip size={18} strokeWidth={2.2} />

                    </button>

                    {
                        showAttachmentMenu && (
                            <div
                                className="vd-wa-attachment-menu"
                                role="menu"
                                aria-label="Opciones de adjunto"
                            >
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => openAttachmentPicker("image/*,video/*")}
                                >
                                    <ImageIcon size={17} strokeWidth={2.2} />
                                    <span>Fotos y videos</span>
                                </button>
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => openAttachmentPicker(".pdf,.doc,.docx,.xls,.xlsx,.txt")}
                                >
                                    <FileText size={17} strokeWidth={2.2} />
                                    <span>Documento</span>
                                </button>
                            </div>
                        )
                    }

                    <input

                        ref={fileInputRef}

                        type="file"

                        style={{
                            display:"none"
                        }}

                        onChange={
                            handleFileSelected
                        }

                    />

                    <button

                        ref={emojiButtonRef}

                        type="button"

                        className="vd-wa-composer-icon vd-wa-composer-emoji"

                        title="Insertar emoji"

                        aria-label="Insertar emoji"

                        onClick={() => {

                            if(!showEmojiPicker){

                                const rect =
                                    emojiButtonRef.current.getBoundingClientRect();

                                setEmojiPickerPosition({

                                    left:rect.left,

                                    top:rect.top

                                });

                            }

                            setShowEmojiPicker(
                                prev => !prev
                            );

                        }}

                        style={{

                            padding:"12px",

                            border:"none",

                            borderRadius:10,

                            cursor:"pointer",

                            background:"#f1f5f9"

                        }}

                    >

                        <Smile size={19} strokeWidth={2.2} />

                    </button>

                    <button

                        type="button"

                        className={`vd-wa-composer-icon vd-wa-composer-mic${isRecording ? " is-recording" : ""}`}

                        title={isRecording ? "Detener grabación" : "Grabar audio"}

                        aria-label={isRecording ? "Detener grabación" : "Grabar audio"}

                        onClick={() => {

                            if (isRecording) {

                                stopRecording();

                            } else {

                                startRecording();

                            }

                        }}

                        style={{
                            padding:"12px",
                            border:"none",
                            borderRadius:10,
                            cursor:"pointer",
                            background:

                            isRecording
                            ? "#ef4444"
                            : "#f1f5f9"

                        }}

                    >

                        {isRecording ? <Square size={17} fill="currentColor" /> : <Mic size={19} strokeWidth={2.2} />}

                    </button>

                    {
                        isRecording && (

                        <div
                            style={{
                                fontSize:12,
                                color:"#ef4444",
                                minWidth:90,
                                display:"flex",
                                alignItems:"center"
                            }}
                        >

                            Grabando...
                            {" "}
                            {recordingTime}s

                        </div>

                        )
                    }

                    <input

                        ref={messageInputRef}

                        value={newMessage}

                        onChange={e =>
                            setNewMessage(
                            e.target.value
                            )
                        }

                        onKeyDown={e => {

                            if (
                                e.key === "Enter" &&
                                !e.shiftKey
                            ) {

                                e.preventDefault();

                                handleSendMessage();

                            }

                        }}

                        placeholder="Escribe un mensaje..."

                        style={{
                            flex:1,
                            padding:12,
                            borderRadius:10,
                            border:"1px solid #cbd5e1"
                        }}

                    />

                    <button

                        type="button"

                        className="vd-wa-composer-send"

                        title="Enviar mensaje"

                        aria-label="Enviar mensaje"

                        disabled={sending}

                        onClick={handleSendMessage}

                        style={{
                            padding:"12px 20px",
                            border:"none",
                            borderRadius:10,
                            background:"#2563eb",
                            color:"#fff",
                            cursor:
                                sending
                                    ? "not-allowed"
                                    : "pointer",
                            opacity:
                                sending
                                    ? 0.6
                                    : 1
                        }}

                    >

                        {sending ? <LoaderCircle size={18} className="vd-wa-spin" /> : <Send size={18} strokeWidth={2.2} />}

                    </button>

                </div>

            </>

        )}

        </div>

        {
            showFilePreview &&
            selectedFile && (

            <div
            style={{
            position:"fixed",
            inset:0,
            background:"rgba(0,0,0,.5)",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            zIndex:9999
            }}
            >

            <div
            style={{
            background:"#fff",
            padding:24,
            borderRadius:16,
            width:450,
            maxWidth:"90%"
            }}
            >

            <h3>

            Archivo seleccionado

            </h3>

            {
                selectedFile?.type?.startsWith(
                    "image/"
                ) && (

                <div
                style={{
                    marginTop:20,
                    textAlign:"center"
                }}
                >

                <img

                    src={previewUrl}

                    alt="preview"

                    style={{
                        maxWidth:"100%",
                        maxHeight:300,
                        borderRadius:12,
                        border:"1px solid #e5e7eb"
                    }}

                />

                </div>

                )
            }

            {
                selectedFile?.type ===
                "application/pdf" && (

                <div
                style={{
                    marginTop:20,
                    padding:20,
                    border:"1px solid #e5e7eb",
                    borderRadius:12,
                    textAlign:"center"
                }}
                >

                <div
                style={{
                    fontSize:48
                }}
                >

                📄

                </div>

                <div>

                PDF

                </div>

                </div>

                )
            }

            {
                selectedFile &&
                !selectedFile.type.startsWith(
                    "image/"
                ) &&
                selectedFile.type !==
                "application/pdf" && (

                <div
                style={{
                    marginTop:20,
                    padding:20,
                    border:"1px solid #e5e7eb",
                    borderRadius:12,
                    textAlign:"center"
                }}
                >

                <div
                style={{
                    fontSize:48
                }}
                >

                📎

                </div>

                <div>

                Documento

                </div>

                </div>

                )
            }

            <div
            style={{
            marginTop:12
            }}
            >

            <strong>
            Nombre:
            </strong>

            {" "}

            {selectedFile.name}

            </div>

            <div
            style={{
            marginTop:8
            }}
            >

            <strong>
            Tamaño:
            </strong>

            {" "}

            {
            (
            selectedFile.size /
            1024
            ).toFixed(1)
            }

            KB

            </div>

            <div
                style={{
                marginTop:20
                }}
                >

                <input

                value={fileCaption}

                onChange={e =>
                    setFileCaption(
                    e.target.value
                    )
                }

                placeholder="Mensaje opcional..."

                style={{
                    width:"100%",
                    padding:12,
                    borderRadius:10,
                    border:"1px solid #cbd5e1"
                }}

                />

            </div>

            <div
            style={{
            marginTop:24,
            display:"flex",
            justifyContent:"flex-end",
            gap:12
            }}
            >

            <button

            onClick={() => {

                setShowFilePreview(
                false
                );

                setSelectedFile(
                null
                );

                setPreviewUrl(
                ""
                );

                setFileCaption(
                ""
                );

            }}

            >

            Cancelar

            </button>

            <button

                onClick={async () => {

                if (!selectedFile) {
                    return;
                }

                try {

                    setUploadingFile(
                    true
                    );

                    const {
                        result,
                        fileDoc
                    } = await sendFileToWhatsApp({

                        clinicId,

                        phone:
                            conversation.whatsapp ||
                            conversation.id?.replace(
                                "@c.us",
                                ""
                            ),

                        file:
                            selectedFile,

                        caption:
                            fileCaption,

                        conversationId:
                            conversation.id,

                        db,

                        storage,

                        collection,

                        addDoc,

                        ref,

                        uploadBytes,

                        getDownloadURL

                    });

                    if (fileDoc) {

                        try {

                            await updateDoc(
                                fileDoc,
                                {
                                    status: result?.success
                                        ? "sent"
                                        : "failed"
                                }
                            );

                        } catch (err) {

                            console.error(
                                "UPDATE STATUS ERROR:",
                                err
                            );

                        }

                    }

                    setShowFilePreview(false);

                    setSelectedFile(null);

                    setPreviewUrl("");

                    setFileCaption("");

                } catch(error) {

                    console.error(error);

                    alert(
                    error.message
                    );

                } finally {

                    setUploadingFile(
                    false
                    );

                }

                }}

                >

                {
                uploadingFile
                ? "Subiendo..."
                : "Enviar"
                }

            </button>

            </div>

            </div>

            </div>

          )
        }

        {
            showDeleteConversationModal && (

            <div
            style={{

                position:"fixed",

                inset:0,

                background:"rgba(0,0,0,.45)",

                display:"flex",

                alignItems:"center",

                justifyContent:"center",

                zIndex:99999

            }}
            >

            <div
            style={{

                width:430,

                maxWidth:"90%",

                background:"#fff",

                borderRadius:18,

                padding:28,

                boxShadow:

                "0 20px 60px rgba(0,0,0,.25)"

            }}
            >

            <div
            style={{

                fontSize:22,

                fontWeight:700,

                marginBottom:20

            }}
            >

            Eliminar conversación

            </div>

            <div
            style={{

                lineHeight:1.6,

                color:"#475569",

                marginBottom:28

            }}
            >

            ¿Deseas eliminar esta conversación de VexaDent?

            <br/><br/>

            Esta acción <b>NO</b> eliminará la conversación del teléfono ni de WhatsApp.

            <br/><br/>

            Si el paciente vuelve a escribir, la conversación se creará nuevamente.

            </div>

            <div
            style={{

                display:"flex",

                justifyContent:"flex-end",

                gap:12

            }}
            >

            <button

            onClick={()=>

            setShowDeleteConversationModal(
            false
            )

            }

            style={{

            padding:"10px 18px",

            borderRadius:10,

            border:"1px solid #cbd5e1",

            background:"#fff",

            cursor:"pointer"

            }}

            >

            Cancelar

            </button>

            <button

            onClick={
            confirmDeleteConversation
            }

            style={{

            padding:"10px 18px",

            borderRadius:10,

            border:"none",

            background:"#dc2626",

            color:"#fff",

            fontWeight:600,

            cursor:"pointer"

            }}

            >

            Eliminar conversación

            </button>

            </div>

            </div>

            </div>

            )
        }

        <FileViewerModal

            isOpen={
                viewerOpen
            }

            onClose={() => {

                setViewerOpen(
                    false
                );

                setViewerUrl(
                    ""
                );

                setViewerName(
                    ""
                );

                setViewerMimeType(
                    ""
                );

            }}

            title={
                viewerName
            }

            fileUrl={
                viewerUrl
            }

            filename={
                viewerName
            }

            mimeType={
                viewerMimeType
            }

            onWhatsApp={() => {}}

        />

    </div>

  );

}
